(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roshi-buying-guides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeLoop = (loop) => {
      if (loop.dataset.roshiGuidesReady === 'true') return;

      const track = loop.querySelector('[data-roshi-guides-track]');
      const firstGroup = track?.querySelector('.roshi-guides__group');
      if (!track || !firstGroup) return;

      loop.dataset.roshiGuidesReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let offset = 0;
      let loopWidth = 0;
      let previousTime = performance.now();
      let pointerId = null;
      let pointerStart = 0;
      let offsetStart = 0;
      let dragging = false;
      let moved = false;
      let suppressClick = false;
      let resumeAt = 0;

      const normalize = (value) => {
        if (!loopWidth) return value;
        while (value <= -loopWidth) value += loopWidth;
        while (value > 0) value -= loopWidth;
        return value;
      };

      const render = () => {
        if (reduceMotion.matches) {
          track.style.removeProperty('transform');
          return;
        }
        track.style.transform = `translate3d(${offset}px, 0, 0)`;
      };

      const measure = () => {
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        loopWidth = firstGroup.getBoundingClientRect().width + gap;
        offset = normalize(offset);
        render();
      };

      const isPaused = () =>
        reduceMotion.matches ||
        loop.matches(':hover') ||
        loop.contains(document.activeElement) ||
        dragging ||
        document.hidden ||
        performance.now() < resumeAt;

      const frame = (time) => {
        const elapsed = Math.min(time - previousTime, 64);
        previousTime = time;

        if (!isPaused() && loopWidth) {
          offset = normalize(offset - (elapsed * loopWidth) / 52000);
          render();
        }

        requestAnimationFrame(frame);
      };

      const finishDrag = (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;
        if (loop.hasPointerCapture(pointerId)) {
          loop.releasePointerCapture(pointerId);
        }
        dragging = false;
        loop.dataset.roshiDragging = 'false';
        resumeAt = performance.now() + 900;
        suppressClick = moved;
        pointerId = null;
      };

      loop.addEventListener('focusin', render);
      loop.addEventListener('focusout', render);

      loop.addEventListener('pointerdown', (event) => {
        if (reduceMotion.matches || event.button !== 0) return;
        pointerId = event.pointerId;
        pointerStart = event.clientX;
        offsetStart = offset;
        dragging = true;
        moved = false;
        loop.dataset.roshiDragging = 'true';
        loop.setPointerCapture(pointerId);
      });

      loop.addEventListener('pointermove', (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        const distance = event.clientX - pointerStart;
        if (Math.abs(distance) > 5) moved = true;
        if (!moved) return;
        event.preventDefault();
        offset = normalize(offsetStart + distance);
        render();
      });

      loop.addEventListener('pointerup', finishDrag);
      loop.addEventListener('pointercancel', finishDrag);

      loop.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        },
        true
      );

      loop.addEventListener(
        'wheel',
        (event) => {
          const horizontalIntent =
            Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey;
          if (!horizontalIntent || reduceMotion.matches) return;
          event.preventDefault();
          offset = normalize(offset - (event.deltaX || event.deltaY));
          resumeAt = performance.now() + 900;
          render();
        },
        { passive: false }
      );

      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(loop);
      reduceMotion.addEventListener('change', measure);
      document.addEventListener('visibilitychange', () => {
        previousTime = performance.now();
      });

      measure();
      requestAnimationFrame(frame);
    };

    const initializeWithin = (root) => {
      root.querySelectorAll('[data-roshi-guides-loop]').forEach(initializeLoop);
    };

    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => {
      initializeWithin(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roshi-home-v15-sales-loop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeLoop = (loop) => {
      if (loop.dataset.roshiLoopReady === 'true') return;

      const track = loop.querySelector('[data-roshi-product-track]');
      const firstGroup = track?.querySelector('.rv15-product-group');
      if (!track || !firstGroup) return;

      loop.dataset.roshiLoopReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let offset = 0;
      let loopWidth = 0;
      let previousTime = performance.now();
      let pointerId = null;
      let pointerStart = 0;
      let offsetStart = 0;
      let hovered = false;
      let focused = false;
      let dragging = false;
      let moved = false;
      let suppressClick = false;
      let resumeAt = 0;

      const normalize = (value) => {
        if (!loopWidth) return value;
        while (value <= -loopWidth) value += loopWidth;
        while (value > 0) value -= loopWidth;
        return value;
      };

      const render = () => {
        if (reduceMotion.matches) {
          track.style.removeProperty('transform');
          return;
        }
        track.style.transform = `translate3d(${offset}px, 0, 0)`;
      };

      const measure = () => {
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        loopWidth = firstGroup.getBoundingClientRect().width + gap;
        offset = normalize(offset);
        render();
      };

      const isPaused = () =>
        reduceMotion.matches ||
        hovered ||
        focused ||
        dragging ||
        document.hidden ||
        performance.now() < resumeAt;

      const frame = (time) => {
        const elapsed = Math.min(time - previousTime, 64);
        previousTime = time;

        if (!isPaused() && loopWidth) {
          offset = normalize(offset - (elapsed * loopWidth) / 42000);
          render();
        }

        requestAnimationFrame(frame);
      };

      const finishDrag = (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;

        if (loop.hasPointerCapture(pointerId)) {
          loop.releasePointerCapture(pointerId);
        }

        dragging = false;
        loop.dataset.roshiDragging = 'false';
        resumeAt = performance.now() + 900;
        suppressClick = moved;
        pointerId = null;
      };

      loop.addEventListener('pointerenter', () => {
        hovered = true;
      });

      loop.addEventListener('pointerleave', () => {
        hovered = false;
      });

      loop.addEventListener('focusin', () => {
        focused = true;
      });

      loop.addEventListener('focusout', (event) => {
        focused = loop.contains(event.relatedTarget);
      });

      loop.addEventListener('pointerdown', (event) => {
        if (reduceMotion.matches || event.button !== 0) return;

        pointerId = event.pointerId;
        pointerStart = event.clientX;
        offsetStart = offset;
        dragging = true;
        moved = false;
        loop.dataset.roshiDragging = 'true';
      });

      loop.addEventListener('pointermove', (event) => {
        if (!dragging || event.pointerId !== pointerId) return;

        const distance = event.clientX - pointerStart;
        if (Math.abs(distance) > 5 && !moved) {
          moved = true;
          loop.setPointerCapture(pointerId);
        }
        if (!moved) return;

        event.preventDefault();
        offset = normalize(offsetStart + distance);
        render();
      });

      loop.addEventListener('pointerup', finishDrag);
      loop.addEventListener('pointercancel', finishDrag);

      loop.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        },
        true
      );

      loop.addEventListener(
        'wheel',
        (event) => {
          const horizontalIntent =
            Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey;
          if (!horizontalIntent || reduceMotion.matches) return;

          event.preventDefault();
          const distance = event.deltaX || event.deltaY;
          offset = normalize(offset - distance);
          resumeAt = performance.now() + 900;
          render();
        },
        { passive: false }
      );

      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(loop);
      reduceMotion.addEventListener('change', measure);
      document.addEventListener('visibilitychange', () => {
        previousTime = performance.now();
      });

      measure();
      requestAnimationFrame(frame);
    };

    const initializeWithin = (root) => {
      root.querySelectorAll('[data-roshi-product-loop]').forEach(initializeLoop);
    };

    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => {
      initializeWithin(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-hero-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root){
    if(!root || root.dataset.heroInited === '1') return;
    root.dataset.heroInited = '1';

    const track = root.querySelector('.hero-track');
    if(!track) return;

    const slides = Array.from(track.children);
    const n = slides.length;

    const dotsWrap = root.querySelector('.dots');
    const prevBtn = root.querySelector('.arrow.prev');
    const nextBtn = root.querySelector('.arrow.next');

    let index = 0;
    let timer = null;

    const idxPrev = (i) => (i - 1 + n) % n;
    const idxNext = (i) => (i + 1) % n;

    function syncState(){
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index);
        s.classList.toggle('is-prev', i === idxPrev(index));
        s.classList.toggle('is-next', i === idxNext(index));
      });

      if(dotsWrap){
        dotsWrap.querySelectorAll('button').forEach((b,i)=>{
          b.setAttribute('aria-current', i===index ? 'true' : 'false');
        });
      }
    }

    function go(i){
      if(n < 2){
        index = 0;
        syncState();
        return;
      }
      index = (i + n) % n;
      track.style.transform = `translate3d(-${index * 100}%,0,0)`;
      syncState();
    }

    if(dotsWrap){
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.className = 'dot';
        b.type = 'button';
        b.setAttribute('aria-label', `Go to slide ${i+1}`);
        b.addEventListener('click', () => go(i));
        dotsWrap.appendChild(b);
      });
    }

    prevBtn && prevBtn.addEventListener('click', () => go(index - 1));
    nextBtn && nextBtn.addEventListener('click', () => go(index + 1));

    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval || '5000', 10);
    const loop = root.dataset.loop === 'true';
    const pauseOnHover = root.dataset.pause === 'true';

    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function start(){
      if(!autoplay || n < 2) return;
      stop();
      timer = setInterval(() => {
        if(index === n - 1 && !loop){ stop(); return; }
        go(index + 1);
      }, interval);
    }

    if(pauseOnHover){
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }

    let sx=0, dx=0;
    root.addEventListener('touchstart', e=>{ sx = e.touches[0].clientX; }, {passive:true});
    root.addEventListener('touchmove', e=>{ dx = e.touches[0].clientX - sx; }, {passive:true});
    root.addEventListener('touchend', ()=> {
      if(Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      dx=0;
    });

    go(0);
    start();

    root._heroCleanup = stop;
  }

  function boot(){
    document.querySelectorAll('[data-super-hero="1"]').forEach(init);
  }

  boot();

  if(window.Shopify && Shopify.designMode){
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('[data-super-hero="1"]').forEach(r => r.dataset.heroInited = '0');
      boot();
    });
    document.addEventListener('shopify:section:unload', () => {
      document.querySelectorAll('[data-super-hero="1"]').forEach(r => r._heroCleanup && r._heroCleanup());
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
